import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=8dda1824&"
import script from "./EmptyLayout.vue?vue&type=script&lang=ts&"
export * from "./EmptyLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports